package com.merkost.handpass.sharedweb.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.silk.style.toAttrs
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.builders.InputAttrsScope
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.dom.Input

@Composable
fun WebInput(
    value: String,
    onValueChange: (String) -> Unit,
    placeholder: String = "",
    type: InputType<String> = InputType.Text,
    enabled: Boolean = true,
    widthPx: Int? = null,
    ariaLabel: String? = null,
    id: String? = null,
    name: String? = null,
    describedBy: String? = null,
    required: Boolean = false,
    classNames: List<String> = emptyList(),
) {
    Input(
        type = type,
        attrs = WebFieldStyle.toAttrs<InputAttrsScope<String>> {
            value(value)
            onInput { onValueChange(it.value) }
            if (placeholder.isNotEmpty()) placeholder(placeholder)
            if (!enabled) disabled()
            if (ariaLabel != null) attr("aria-label", ariaLabel)
            if (id != null) id(id)
            if (name != null) attr("name", name)
            if (describedBy != null) attr("aria-describedby", describedBy)
            if (required) attr("required", "")
            classNames.forEach { classes(it) }
            if (widthPx != null) style { property("max-width", "${widthPx}px") }
        }
    )
}
